// src/App.js
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setSettings } from "redux/actions/Settings";
import { useLocation } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import Routers from "./Routers";
import { initializeGtag } from "./utils/gtag";
import { THEME_CONFIG, PUBLIC_RECAPTCHA_KEY } from "./configs/AppConfig";
import "assets/css/antdCustom.css";

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    // Extract locale from the first segment of the pathname (e.g., "/en/register")
    const pathSegments = location.pathname.split('/');
    const localeFromPath = pathSegments[1] || "en"; // fallback to "en" if not provided

    // Determine text direction based on locale (adjust if you have additional locales)
    const direction = localeFromPath === "fa" ? "rtl" : "ltr";

    dispatch(setSettings(localeFromPath, direction));
  }, [location, dispatch]);

  useEffect(() => {
    // Initialize Google Analytics
    initializeGtag();
  }, []);

  return (
    <div className="App">
      <GoogleReCaptchaProvider
        useRecaptchaNet
        reCaptchaKey={PUBLIC_RECAPTCHA_KEY} // Ensure this key is defined in your configs
        scriptProps={{ async: true, defer: true, appendTo: "body" }}
      >
        <ThemeSwitcherProvider
          themeMap={themes}
          defaultTheme={THEME_CONFIG.currentTheme}
          insertionPoint="styles-insertion-point"
        >
          <Routers />
        </ThemeSwitcherProvider>
      </GoogleReCaptchaProvider>
    </div>
  );
};

export default App;
